import {useTranslation} from "react-i18next";

interface LanguageSwitcherProps {
    /**
     * @param {string} [className] Provide additional classes
     */
    bgColour?: string,
    /**
     * @param {string} [className] Provide additional classes
     */
    textColour?: string,
}

function LanguageSwitcher(props: LanguageSwitcherProps){

    const { t, i18n } = useTranslation(['translation']);

    const changeLanguageHandler = (e: any) => {
        const languageValue = e.target.value
        i18n.changeLanguage(languageValue);
        document.documentElement.lang = i18n.language;

        const rtlLangs = [
            'ar'
        ];

        const gameEl = document.getElementById('wsd-spotter-game');

        if (gameEl) {
            if (rtlLangs.includes(e.target.value)) {
                gameEl.setAttribute('dir', 'rtl');
            } else {
                gameEl.setAttribute('dir', 'ltr');
            }
        }
    }

    return(
        <div className="ro-absolute ltr:ro-right-0 rtl:ro-left-0 ro-bottom-0 md:ro-bottom-auto md:ro-top-0 ro-z-50 ltr:ro-pr-8 rtl:ro-pl-8 ro-pb-8 md:ro-pb-0 md:ro-pt-8">
            <div className={`ro-p-2 md:ro-p-3 ${props.bgColour} ro-rounded-3xl`}>
                <select className={`ro-font-poppins ro-font-semibold ${props.textColour} ro-bg-white ro-rounded-3xl custom-select focus:ro-outline-none ro-text-xs md:ro-text-base`} onChange={changeLanguageHandler} value={i18n.language}>
                    <option value="en">{t('languages.english')}</option>
                    <option value="ar">{t('languages.arabic')}</option>
                    <option value="zh">{t('languages.chinese')}</option>
                    <option value="fr">{t('languages.french')}</option>
                    <option value="hi">{t('languages.hindi')}</option>
                    <option value="pt">{t('languages.portuguese')}</option>
                    {/* <option value="si">{t('languages.slovenian')}</option> */}
                    <option value="es">{t('languages.spanish')}</option>
                </select>
            </div>
        </div>
    )
}

export { LanguageSwitcher }